import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function NotFound() {
  return (
    <div className="bg-fc-navy min-h-screen text-white flex flex-col" data-testid="not-found-page">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-6 py-32">
        <div className="text-center max-w-xl">
          <div className="fc-overline mb-3">404</div>
          <h1 className="fc-h-hero text-6xl sm:text-7xl mb-4">
            <span className="text-fc-red">Off-road.</span>
          </h1>
          <p className="text-white/60 text-lg mb-8 leading-relaxed">
            The page you tried to load doesn't exist on the academy yet. Head back
            and pick a program.
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Link to="/" className="btn-fc-red">Back to Home</Link>
            <Link to="/courses" className="btn-fc-outline">Browse Courses</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
